var _path, _g, _circle, _circle2, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLowFees = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3682_16798)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3682_16798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.143 6H16C10.477 6 6 10.477 6 16v21.143c0 5.523 4.477 10 10 10h21.143c5.523 0 10-4.477 10-10V16c0-5.523-4.477-10-10-10Z",
    fill: "url(#paint0_linear_3682_16798)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3682_16798)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3682_16798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.143 6H16C10.477 6 6 10.477 6 16v21.143c0 5.523 4.477 10 10 10h21.143c5.523 0 10-4.477 10-10V16c0-5.523-4.477-10-10-10Z",
    fill: "url(#paint1_linear_3682_16798)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.25h21.143c5.385 0 9.75 4.365 9.75 9.75v21.143c0 5.385-4.365 9.75-9.75 9.75H16c-5.385 0-9.75-4.365-9.75-9.75V16c0-5.385 4.365-9.75 9.75-9.75Z",
    stroke: "url(#paint2_linear_3682_16798)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3682_16798)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.947,
    cy: 45.745,
    rx: 8.254,
    ry: 7.687,
    fill: "#EDA54D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3682_16798)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.539,
    cy: 5.973,
    rx: 8.254,
    ry: 7.687,
    fill: "#95F0FB"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.571,
    cy: 20.571,
    r: 3.286,
    stroke: "#C9975A",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.571,
    cy: 32.571,
    r: 3.286,
    stroke: "#C9975A",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3682_16798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.715 33.43 13.714-13.715",
    stroke: "#191818",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3682_16798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.268 45.45v-8.593H41.59v8.593h-4.733L45.43 54 54 45.45h-4.732Z",
    fill: "url(#paint3_linear_3682_16798)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3682_16798",
    x: 0,
    y: 0,
    width: 53.143,
    height: 53.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3682_16798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3682_16798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3682_16798",
    x: -7.307,
    y: 12.058,
    width: 68.507,
    height: 67.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3682_16798"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3682_16798",
    x: 2.285,
    y: -27.715,
    width: 68.507,
    height: 67.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_3682_16798"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3682_16798",
    x: 17.715,
    y: 18.215,
    width: 17.714,
    height: 17.714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3682_16798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3682_16798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3682_16798",
    x: 26.857,
    y: 28.857,
    width: 41.143,
    height: 41.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0901961 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3682_16798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3682_16798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3682_16798",
    x1: 26.571,
    y1: 6,
    x2: 26.571,
    y2: 47.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#272625",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3682_16798",
    x1: 26.571,
    y1: 6,
    x2: 26.571,
    y2: 47.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B1A",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1B1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3682_16798",
    x1: 26.571,
    y1: 6,
    x2: 26.571,
    y2: 24.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292725",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3682_16798",
    x1: 45.429,
    y1: 36.857,
    x2: 45.429,
    y2: 55.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A07041"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3682_16798"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgLowFees;